import {$qs, $qsAll} from '../../@shared/ts/dom';
import {setInnerView} from './ui-utils';

function initNavigationEvents() {
	// Add event listeners to the top navigation dropdown
	document.querySelector('.top-nav-link.current')?.addEventListener('click', (event: Event) => {
		event.stopImmediatePropagation();
		const $topNavContainer = (event.target as HTMLElement)?.closest('.top-nav-link-group');
		if (window.innerWidth > 1399) {
			$topNavContainer?.classList.remove('expanded');
		} else {
			event.preventDefault();
			$topNavContainer?.classList.toggle('expanded');
		}

		if ($topNavContainer?.classList.contains('expanded')) {
			const __listener = (event: Event) => {
				if (!(event.target as HTMLElement)?.closest('.peachpay-accordion') || !(event.target as HTMLElement)?.closest('.peachpay-accordion')?.contains($topNavContainer)) {
					$topNavContainer?.classList.remove('expanded');
					document.removeEventListener('click', __listener);
				}
			};

			document.addEventListener('click', __listener);
		}
	});

	document.querySelector('.hamburger-menu')?.addEventListener('click', () => {
		const disablePointerEvents = () => {
			$qsAll('.pp-admin-content, #peachpay-nav, #wpadminbar').forEach(($element: HTMLElement) => {
				$element.style.pointerEvents = 'none';
			});
		};

		const enablePointerEvents = () => {
			$qsAll('.pp-admin-content, #peachpay-nav, #wpadminbar').forEach(($element: HTMLElement) => {
				$element.style.pointerEvents = 'all';
			});
		};

		const clickListener = (event: Event) => {
			if (!(event.target as HTMLElement)?.classList.contains('hamburger-menu') && !(event.target as HTMLElement)?.closest('.peachpay-side-nav')) {
				document.querySelector('.peachpay-side-nav')?.classList.remove('shown');
				document.removeEventListener('click', clickListener);
				document.body.style.removeProperty('overflow');
				enablePointerEvents();
			}
		};

		disablePointerEvents();
		document.querySelector('.peachpay-side-nav')?.classList.add('shown');
		document.body.style.overflow = 'hidden';
		document.addEventListener('click', clickListener);
	});
}

function navigationDefaultHash() {
	const $subNavControl = $qs('.pp-sub-nav-controller')?.firstElementChild;
	if (!$subNavControl) {
		return null;
	}

	return $subNavControl.getAttribute('href')?.split('#')[1] ?? '';
}

function initNavigationUIState() {
	// Render the UI state based on the hash
	const hash = window.location.hash === '' ? navigationDefaultHash() : window.location.hash.slice(1);
	if (hash) {
		// Set URL hash without the page jump
		window.location.hash = '';
		// This is because the browser hasn't jumped to the hash ref yet on DOMContentLoaded.
		window.addEventListener('load', () => {
			window.location.hash = `#${hash}`;
			document.documentElement.scrollTop = 0;
			setInnerView(hash);
		});
	}

	// Set maximum side navigation height without scrolling based on top offset
	const $sideNav = $qs('.peachpay-side-nav')!;
	if ($sideNav) {
		const fitSideNav = () => {
			if (window.innerHeight < 835 && window.innerWidth > 782) {
				const totalHeight = document.body.clientHeight;
				const maxSideNavHeight = Math.min(totalHeight - 100, 750);
				$sideNav.style.maxHeight = `${maxSideNavHeight}px`;
			} else {
				$sideNav.style.removeProperty('max-height');
			}
		};

		fitSideNav();
		window.addEventListener('resize', () => {
			fitSideNav();
		});
		$qsAll('.pp-sub-nav-button').forEach(($subNavButton: HTMLElement) => {
			$subNavButton.addEventListener('click', () => {
				fitSideNav();
			});
		});
	}
}

export {initNavigationEvents, initNavigationUIState};
